import React from "react";
import { useTranslation } from "react-i18next";
import { getEnumTKey } from "@/utils/strings";
import { CompanyData, CompanyStatus } from "@/pages/companies/types";
import Text from "@/components/ui/text";
import { companyStatusColors } from "@/pages/companies/Companies";
import TopFields, { FieldsConfig } from "@/components/layouts/TopFields";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import IconContainer from "@/components/ui/icon-container";
import { Bullet } from "@dreamhub/designsystem/icons";

interface Props {
  company?: CompanyData;
  onUpdateField: (field: string, newValue: string | number) => void;
  className?: string;
  itemClassName?: string;
}

const CompanyTopFields: React.FC<Props> = ({
  company,
  onUpdateField,
  className,
  itemClassName
}) => {
  const { t } = useTranslation();
  const renderStatus = () => (
    <div className="flex items-center gap-1 pr-2">
      <IconContainer
        style={{
          color: companyStatusColors[company?.status as CompanyStatus]
        }}
      >
        <Bullet />
      </IconContainer>
      <Text variant="body">
        {t(
          getEnumTKey(
            "companies",
            "statusValues",
            CompanyStatus,
            company?.status as number
          )
        )}
      </Text>
    </div>
  );

  const fieldsConfig: FieldsConfig = {
    status: {
      type: "nonEditable",
      defaultValue: CompanyStatus.PROSPECT,
      customComponent: (
        <Tooltip>
          <TooltipTrigger>{renderStatus()}</TooltipTrigger>
          <TooltipContent maxWidth={18} align="start" sideOffset={4}>
            <div className="flex gap-1">
              {t(
                getEnumTKey(
                  "companies",
                  "statusesTooltips",
                  CompanyStatus,
                  company?.status as number
                )
              )}
            </div>
          </TooltipContent>
        </Tooltip>
      )
    }
  };

  return (
    <TopFields
      entity={company}
      fieldsConfig={fieldsConfig}
      onUpdateField={onUpdateField}
      className={className}
      itemClassName={itemClassName}
    />
  );
};

export default CompanyTopFields;
